var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.294,
    viewBox: "0 0 16 14.294",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tasks",
    transform: "translate(-111.105 -48.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34519",
    "data-name": "Path 34519",
    d: "M117.11,217.172l-3.069,2.738-1.682-1.682a.561.561,0,0,0-.792.792l2.056,2.056h0a.561.561,0,0,0,.77.022l3.465-3.084a.561.561,0,1,0-.748-.837Z",
    transform: "translate(-0.255 -162.559)",
    fill: "parentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34520",
    "data-name": "Path 34520",
    d: "M357.419,262.7h-6.86a.561.561,0,0,0,0,1.122h6.86a.561.561,0,1,0,0-1.122Z",
    transform: "translate(-230.875 -206.699)",
    fill: "parentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34522",
    "data-name": "Path 34522",
    d: "M241.425,430.7H230.56a.561.561,0,1,0,0,1.121h10.865a.561.561,0,1,0,0-1.121Z",
    transform: "translate(-114.88 -369.092)",
    fill: "parentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34523",
    "data-name": "Path 34523",
    d: "M117.9,49.052a.561.561,0,0,0-.793-.045l-3.069,2.738-1.682-1.682a.561.561,0,0,0-.792.792l2.056,2.056h0a.561.561,0,0,0,.77.022l3.465-3.084a.561.561,0,0,0,.045-.8Z",
    transform: "translate(-0.249)",
    fill: "parentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34524",
    "data-name": "Path 34524",
    d: "M357.419,94.7h-6.86a.561.561,0,0,0,0,1.122h6.86a.561.561,0,1,0,0-1.122Z",
    transform: "translate(-230.875 -44.301)",
    fill: "parentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1298",
    "data-name": "Ellipse 1298",
    cx: 1.005,
    cy: 1.005,
    r: 1.005,
    transform: "translate(111.105 61.148)",
    fill: "parentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.5d8910d67531c9f802902b6654ce2d54.svg";
export { ForwardRef as ReactComponent };